"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Delete_1 = require("./_Delete");
exports.DeleteObjectsInput = {
    type: "structure",
    required: ["Bucket", "Delete"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        Delete: {
            shape: _Delete_1._Delete,
            locationName: "Delete",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        },
        MFA: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-mfa"
        },
        RequestPayer: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-request-payer"
        }
    },
    payload: "Delete"
};
//# sourceMappingURL=DeleteObjectsInput.js.map